import React, { FC } from "react";
import { Modal } from "antd";

export type NotificationMessageModalProps = {
  message: string;
  handleOkClick: () => void;
};

export const NotificationMessageModal: FC<NotificationMessageModalProps> = ({
  message,
  handleOkClick,
}) => {
  return (
    <>
      <Modal
        title={"Message Shared"}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
        visible={true}
        okText="Dismiss"
        onOk={handleOkClick}
      >
        <p>{message}</p>
      </Modal>
    </>
  );
};
